import { BlogRelated } from "@components/blog/BlogRelated"
import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { BlogTileFragment } from "@generated-types"
import { defineView } from "eddev/views"

export default defineView("single-blog", (props) => {
  return (
    <>
      <SubpageContentBlocks blocks={props.blogPost?.contentBlocks} />
      <div className="h-10" />
      <BlogRelated
        currentSlug={props.blogPost?.uri || undefined}
        posts={props.blogPost?.info?.category?.contentNodes?.nodes as BlogTileFragment[]}
      />
      <div className="h-10" />
    </>
  )
})
